import { Component } from '@angular/core';

import { SpecificComponent } from '../specific.component';
import { BckpServerSearchResult } from 'src/app/_common/models/search-result';

@Component({
    selector: 'aa-search-result-bckp-server',
    templateUrl: './bckp-server.component.html',
    styleUrls: [
        '../specific-shared.scss',
        '../../../../../../customer/bckp/servers/serv/serv-list/columns-shared.scss',
        './bckp-server.component.scss'
    ],
    standalone: false
})
export class BckpServerComponent extends SpecificComponent<BckpServerSearchResult>
{
    constructor ()
    {
        super();
    }
}
